import axios from '../../axios'

/*
 * 准考证号数据接口
 */

// 获取准考证号列表
export const getTicketList = (data) => {
    return axios({
        url: '/api/mock/aff/ticket',
        method: 'get',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/moudules/aff/ticket.js